/** Small rotating loading indicator — used wherever content takes a moment to become ready (e.g. a series chart while its CSV is still being parsed) instead of leaving that area blank. */
export function Spinner({ label }: { label?: string }) {
  return (
    <div className="spinner-container" role="status" aria-label={label}>
      <div className="spinner" />
    </div>
  );
}
